import React from 'react';

import styled from 'styled-components';

import EmptyLayoutIllustration from './Illustration.png';

const EmptyAssignmentRulesWrapper = styled.div`
  gap: 8px;
  display: flex;
  padding: 24px 0px;
  align-items: center;
  align-self: stretch;
  flex-direction: column;
  min-height: 50vh;
  justify-content: center;

  p {
    color: ${({ theme }) => theme.palette.primary.dark};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
    letter-spacing: 0.15px;
  }
`;

const EmptyAssignmentRules = (): React.ReactElement => (
  <EmptyAssignmentRulesWrapper>
    <img width={152} height={118} alt="EmptyLayoutIllustration" src={EmptyLayoutIllustration} />
    <p>Add your first rule and start editing</p>
  </EmptyAssignmentRulesWrapper>
);

export default EmptyAssignmentRules;
